import React from "react";

export default function Header() {
  return (
    <>
  <nav class="navbar navbar-expand-lg navbar-light bg-white navbar-fixed-top">
      <div class="container">
        <a class="navbar-brand" href="./index.html">
          <img src="/img/Logo22.svg" class="navbar-brand-img w-100" alt="..."/>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fe fe-x"></i>
          </button>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarLandings" data-toggle="dropdown" href="/" aria-haspopup="true" aria-expanded="false">
                Home
              </a>
            </li>
 <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarLandings" data-toggle="dropdown" href="/about" aria-haspopup="true" aria-expanded="false">
                About Us
              </a>
            </li>
 <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarLandings" data-toggle="dropdown" href="#" aria-haspopup="true" aria-expanded="false">
                Solutions
              </a>
            </li>
 <li class="nav-item dropdown">
              <a href='/blogs' class="nav-link dropdown-toggle" id="navbarLandings" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Blogs
              </a>
            </li>
 <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarLandings" data-toggle="dropdown" href="#" aria-haspopup="true" aria-expanded="false">
                Social Media
              </a>
            </li>
 <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarLandings" data-toggle="dropdown" href="/connect" aria-haspopup="true" aria-expanded="false">
                Connect
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </>
  );
}
